import GeoJSON from 'geojson'

function deg2rad(deg) {
  return deg * (Math.PI / 180)
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371 // Radio de la tierra en KM
  const dLat = deg2rad(lat2 - lat1)
  const dLon = deg2rad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) // Distancia en KM
}

export default {
  getGeojson(shapes) {
    const data = shapes.map(position => [position.lng, position.lat])
    if (data.length === 0) {
      return undefined
    }
    const dataPoints = {
      polyline: data
    }
    const geojson = GeoJSON.parse(dataPoints, {LineString: 'polyline'})
    return geojson
  },
  coordsToLatLngs(geojson) {
    return L.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates)
  },
  distance(p1, p2) {
    return getDistanceFromLatLonInKm(p1.lat, p1.lng, p2.lat, p2.lng)
  }
}
